// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../CommunityWebPortal/_app/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "tr.new td[data-v-c98adf26]{background:#d7f6c5}tr.remove td[data-v-c98adf26]{background:#ffcbc4}", ""]);
// Exports
module.exports = exports;
